module.exports = __webpack_public_path__ + "img/new_tool_rho.02c27ca5.png";